import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	"aria-hidden": "true",
	focusable: "false",
	"data-prefix": "fas",
	"data-icon": "plus",
	className: "svg-inline--fa fa-plus fa-w-14",
	role: "img",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 448 512",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
	})]
});
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
